<template>
    <div class="lang-switch-dropdown">
        <Dropdown trigger="click" @on-click="setLang">
            <a href="javascript:void(0)">
                <Icon :style="{marginTop: '-2px', verticalAlign: 'middle'}" color="#495060" :size="18"
                      type="md-planet"></Icon>
                <Icon type="md-arrow-dropdown"/>
            </a>
            <DropdownMenu slot="list">
                <DropdownItem name="zh-CN">中国语</DropdownItem>
                <DropdownItem name="ja-JP">日本语</DropdownItem>
            </DropdownMenu>
        </Dropdown>
    </div>
</template>

<script>
export default {
    name: 'langSwitch',
    data() {
        return { value: false };
    },
    methods: {
        setLang(lang) {
            localStorage.lang = lang;
            this.$router.go(0);
        },
    },
};
</script>
<style lang="less" scoped>
.lang-switch-dropdown {
    padding: 0 6px;
    display: inline-block;
    vertical-align: middle;
    line-height: 0px;
}
</style>
